import React, { useState } from "react";
import { ReactComponent as Search } from "../../../../Assets/search.svg";
import Button from "Components/UI/Button/Button";
import { Input, Switch } from "antd";
import { FilterItemProps } from "Components/PageTable/PageTable";
import styled from "./Match.module.scss";

const Miles: React.FC<FilterItemProps> = ({ openStateToggler: toggleOpenState }) => {
  const [mode, setMode] = useState("inline");
  const changeMode = () => {
    setMode(mode ? "vertical" : "inline");
  };
  return (
    <div className={styled.container}>
      <div className={styled.container__backg}>
        <h4 className={styled.container__backg__text}>Nearest drivers</h4>
        <div className={styled.container__backg__registr}>
          <Input
            defaultValue="1-50"
            className={styled.container__backg__registr_input}
          />

          <Search className={styled.container__backg__registr_icon} />
        </div>
        <div className={styled.container__backg__switch}>
          <Switch onChange={changeMode} />
          <span className={styled.container__backg__switch_match}>Match</span>
        </div>
        <Button
          className={styled.container__backg_btn}
          onClick={toggleOpenState}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default Miles;
